/**
 * WordPress Dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';
import { Fragment, useEffect } from '@wordpress/element';

/**
 * External Dependencies
 */
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import { handleUniqueId } from '../../helper';

// inspector controls
import Inspector from './inspector';

// Dynamic Style
import DynamicStyle from './dynamic-style';

// block edit function
const Edit = props => {
    const { attributes, setAttributes, clientId, isSelected, context } = props;
    const { uniqueId, aff_btnSizeType, label, progressmatify, isVisibe } = attributes;

    /**
     * Handle Block Unique Id
     */
    useEffect(() => {
        handleUniqueId({ uniqueId, setAttributes, clientId });
    }, [uniqueId, setAttributes, clientId]);

    /**
     * Block Props
     */
    const blockProps = useBlockProps({
        className: classNames(uniqueId, aff_btnSizeType)
    });

    // Change context
    useEffect(() => {
        setAttributes({ isVisibe: context['progressmatify/aff_toggle'] });
    }, [context, setAttributes]);
    console.log('isVisibe', isVisibe);
    return (
        <Fragment>
            {isSelected && <Inspector {...props} />}
            <DynamicStyle {...props} />
            <div {...blockProps}>
                <div className="gbk-pdReview-criteria-warp">
                    <div className="gbk-pdReview-bar-item">
                        <div className="gbk-pdReview-bar-content">
                            {isVisibe && <span className="gbk-pdReview-bar-title">{label}</span>}
                            <span className="gbk-pdReview-bar-percent">{progressmatify}%</span>
                        </div>
                        <div className="gbk-pdReview-bar-progressmatify">
                            <div className="progressmatify-bar">
                                <div className="progressmatify-bar-fill fill-item1" style={{ width: `${progressmatify}% ` }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Edit;
